<template>
  <AppDialog
    class="custom-confirm-dialog"
    :title="`${editing ? 'Edit' : 'Delete'} option confirmation`"
    :show="show"
    append-to-body
    @close="close"
  >
    <form @submit.prevent="onFormSubmit">
      <div
        v-if="selection.usage"
        class="dialog-warning orange d-flex align-items-center mb-5 gap-5"
      >
        <i class="hi hi-warning text-orange mr-5" />
        <div v-if="editing">{{ selection.usage }} member profiles will be updated if you proceed</div>
        <div v-else>
          {{ selection.usage }} member profiles will not have a {{ selection.title }} selection if you proceed. Member
          profiles can be
          <a
            :href="supportURL"
            rel="noopener noreferrer"
            target="_blank"
          >
            batch updated by CSV import
          </a>
          <span>.</span>
        </div>
      </div>
      <div class="footer">
        <div class="d-flex mt-40">
          <AppButton
            v-if="!editing"
            type="danger"
            @click="onFormSubmit"
          >
            Confirm delete
          </AppButton>
          <div class="ml-auto">
            <AppButton
              type="default"
              @click="close"
            >
              Cancel
            </AppButton>
            <button
              v-if="editing"
              class="btn btn-primary ml-15"
              type="submit"
              :disabled="submitting"
            >
              {{ label }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </AppDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MemberProfileCustomConfirmDialog',
  props: {
    field: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
    selection: {
      type: Object,
      required: true,
    },
    newAttributes: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    submitting: false,
    supportURL: 'https://support.hubstaff.com/how-to-update-member-details-via-csv-importer/',
  }),
  computed: {
    ...mapGetters(['organizationId']),
    label() {
      return this.submitting ? 'Confirming...' : 'Confirm';
    },
    editing() {
      return !this.newAttributes.delete;
    },
  },
  methods: {
    ...mapActions(['updateCustomField', 'loadCustomFields']),
    close() {
      this.$emit('close');
    },
    onFormSubmit() {
      this.submitting = true;
      this.updateCustomField({ id: this.organizationId, fieldKey: this.field, items: this.newAttributes.options }).then(
        this.completeRequest,
      );
    },
    completeRequest() {
      this.loadCustomFields();
      this.submitting = false;
      this.$appMessage('Options updated');
      this.$emit('close-all');
      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
  },
};
</script>
